import { BANK_CONNECTION_STATUS } from './constants'

// Underscores read as hyphens, as the bank service may send either.
export const normaliseConnectionStatus = (status?: string | null) =>
  (status ?? '').trim().toLowerCase().replace(/_/g, '-')

const INACTIVE_STATUSES: string[] = [
  BANK_CONNECTION_STATUS.INACTIVE,
  BANK_CONNECTION_STATUS.REVOKED,
  BANK_CONNECTION_STATUS.EXPIRED,
]

// A connection that can no longer sync with its bank.
export const isInactiveConnectionStatus = (status?: string | null) =>
  INACTIVE_STATUSES.includes(normaliseConnectionStatus(status))
